import PrintActions from '../../../actions/PrintActions';
// import NotificationActions from '../../../actions/NotificationActions';

import PosStore from '../../../stores/PosStore';
import NotificationActions from '../../../actions/NotificationActions';
// import ConfigStore from '../../../stores/ConfigStore';

// import { endPoints as EndPoints } from '../../../constants/PosConstants';

class PrintLabel extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            labels : PosStore.getState().labels,
            selectedLabel : ''
        }

        this.printLabel = this.printLabel.bind(this);
    }

    printLabel() {
        if (this.state.selectedLabel.length === 0)
            return;

        var guest = Object.assign({}, this.props.guest, { ShipmentId: this.props.selected.ReceiptNo });
        const error = PrintActions.printLabel(this.props.selected, guest, false, this.state.selectedLabel);
        if(error) {
            NotificationActions.error(error)
        }
    }

    render() {
        var disableSubmit = this.state.selectedLabel.length === 0 ? true : false;
        var labels = this.state.labels;

        return (
            <div className='return-form'>
                <div className='return-form__content'>
                    <div className='return-form__title'>
                        Print Label
                    </div>

                    <div className='return-form__question'>
                        Select Label
                    </div>

                    <div className='return-form__answer'>
                        <select
                            className='return-form__labels input-text-1'
                            value={this.state.selectedLabel}
                            onChange={(e) => { this.setState({ selectedLabel : e.target.value }); }}>

                            <option value=''>
                                Select Label
                            </option>

                            { labels.map((label, i) => {
                                return (
                                    <option
                                        key={'label'+i}
                                        value={label.id}>

                                        {label.LabelDescription}

                                    </option>
                                );
                            })}
                        </select>
                    </div>    

                    <div
                        className='change-payment__back'
                        onClick={() => { this.props.onBack(); }}>

                        BACK
                    </div>

                    <div
                        className={'change-payment__submit '+(disableSubmit ? 'btn-green__disabled' : '')}
                        onClick={this.printLabel}>

                        OK
                    </div>
                </div>
            </div>
        );
    }
}

export default PrintLabel;


// WEBPACK FOOTER //
// ./ui_src/app/components/profile/view/PrintLabel.react.jsx